import { render } from "./InboundCertificateQueue.vue?vue&type=template&id=3026dee4&scoped=true"
import script from "./InboundCertificateQueue.vue?vue&type=script&lang=js"
export * from "./InboundCertificateQueue.vue?vue&type=script&lang=js"

import "./InboundCertificateQueue.vue?vue&type=style&index=0&id=3026dee4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3026dee4"]])

export default __exports__